module.exports = __webpack_public_path__ + "static/media/top-banner-default.bdaa9274.jpg";